import { ArrowLeft, Gear } from '@phosphor-icons/react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { SaveIndicator } from './SaveIndicator';
import { CopyUrlButton } from './CopyUrlButton';
import { useEpisodeStore } from '@/state/episodeStore';
import { isLocalMode } from '@/local';
import { getLastEpisode } from '@/services/lastEpisode';

export function TopBar() {
  const { uuid } = useParams<{ uuid?: string }>();
  const location = useLocation();
  const episode = useEpisodeStore((s) => s.episode);

  const url = uuid ? `${window.location.origin}/episode/${uuid}` : '';
  const onAdmin = location.pathname.startsWith('/admin');
  const lastEpisode = !uuid ? getLastEpisode() : null;

  return (
    <header className="flex h-14 items-center justify-between border-b border-line-1 bg-surface-1 px-5 shadow-[var(--shadow-elev-1)]">
      <div className="flex min-w-0 items-center gap-3">
        {onAdmin && lastEpisode && (
          <Link
            to={`/episode/${lastEpisode}`}
            aria-label="Back to episode"
            className="rounded-md p-1.5 text-text-3 transition-colors hover:bg-surface-2 hover:text-text-1"
          >
            <ArrowLeft size={16} />
          </Link>
        )}
        <h1 className="truncate text-[15px] font-semibold leading-none text-text-1">
          {episode?.title ?? (uuid ? 'Loading…' : 'Merjem Studio')}
        </h1>
        {isLocalMode() && (
          <span
            className="inline-flex items-center gap-1 rounded-sm bg-warn/15 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-warn"
            title="Local mode — running without the Laravel backend. Data lives in localStorage."
          >
            ◌ Local
          </span>
        )}
      </div>

      <div className="flex items-center gap-3">
        {uuid && <SaveIndicator />}
        {url && <CopyUrlButton url={url} />}
        <Link
          to="/admin"
          className="rounded-md p-1.5 text-text-3 transition-colors hover:bg-surface-2 hover:text-text-1"
          aria-label="Admin"
        >
          <Gear size={18} />
        </Link>
      </div>
    </header>
  );
}
